import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('rutex_auth_token') || null);
    const [loading, setLoading] = useState(true);

    // Initial load: parse user from localstorage if available
    useEffect(() => {
        const storedUser = localStorage.getItem('rutex_user');
        if (storedUser && token) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error("Error parsing stored rutex_user:", e);
                setUser(null);
            }
        }
        setLoading(false);
    }, [token]);

    const login = (userData, authToken) => {
        setToken(authToken);
        setUser(userData);
        localStorage.setItem('rutex_auth_token', authToken);
        localStorage.setItem('rutex_user', JSON.stringify(userData));
    };

    const logout = () => {
        setToken(null);
        setUser(null);
        localStorage.removeItem('rutex_auth_token');
        localStorage.removeItem('rutex_user');
    };

    const updateUser = (updatedFields) => {
        setUser(prev => {
            const updated = prev ? { ...prev, ...updatedFields } : updatedFields;
            localStorage.setItem('rutex_user', JSON.stringify(updated));
            return updated;
        });
    };

    return (
        <AuthContext.Provider value={{ user, token, login, logout, updateUser, loading, isAuthenticated: !!token }}>
            {children}
        </AuthContext.Provider>
    );
};
